import { useGoalById } from 'features/goals';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { PageSectionBase } from 'shared/components/ui/page-section-base';
import { useUser } from 'shared/hooks/use-user';
import { getWeekStartsOn } from 'shared/utils/get-week-starts-on';

import { DateRangeSelect } from './components/date-range-select';
import { ProgressOverview } from './components/progress-overview';
import * as Styled from './goal-detail.style';
import { useTimeframeTimes } from './hooks/use-timeframe-times';

export const Progress: React.FC = () => {
  const { t } = useTranslation();
  const user = useUser();
  const weekStartsOn = getWeekStartsOn(user);

  const { id } = useParams();
  const goal = useGoalById(id);
  const goalDateRange = useTimeframeTimes(goal);
  const [dateRange, setDateRange] = useState(goalDateRange);

  return (
    <PageSectionBase
      title={t('pages.goal-detail.progress.title')}
      interactions={
        <DateRangeSelect
          customRange={goalDateRange}
          onChange={setDateRange}
          value={dateRange}
          weekStartsOn={weekStartsOn}
        />
      }
      fullSize
      noPadding
    >
      <Styled.ScrollContainer>
        <ProgressOverview dateRange={dateRange} />
      </Styled.ScrollContainer>
    </PageSectionBase>
  );
};
